import { TextButton } from '@creditornot/cb-button';
import { Tag } from '@creditornot/cb-tag';
import { DateTime } from 'luxon';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { SpinningRotatingArrows } from './CommonStyles';
import { SharedMenu } from '../types';
import { getSelectionState } from '../utils';

type Props = {
  sharedMenu: SharedMenu;
};

const StateTag = styled(Tag).attrs({ size: 'tiny', uppercase: true })``;

const BootstrapInProgress = styled.div`
  display: flex;
  align-items: center;
`;

const SharedMenuStateTag = ({ sharedMenu }: Props) => {
  const selectionState = getSelectionState(sharedMenu);

  if (selectionState === 'bootstrapping') {
    return (
      <BootstrapInProgress>
        <SpinningRotatingArrows />
        <TextButton variant="brand" style={{ marginInlineStart: '4px' }}>
          <FormattedMessage id="shared-menu.status.bootstrap-in-progress" />
        </TextButton>
      </BootstrapInProgress>
    );
  }

  if (selectionState === 'draft') {
    return (
      <StateTag variant="lightBlack">
        <FormattedMessage id="shared-menu.status.draft" />
      </StateTag>
    );
  }

  if (selectionState === 'pending-changes') {
    return (
      <StateTag variant="lightOrange">
        <FormattedMessage id="shared-menu.status.pending-changes" />
      </StateTag>
    );
  }

  if (selectionState === 'scheduled-changes' && sharedMenu.draft?.publish_at) {
    return (
      <StateTag variant="lightBlue">
        <FormattedMessage
          id="shared-menu.status.scheduled-draft"
          values={{
            date: DateTime.fromISO(sharedMenu.draft.publish_at).toLocaleString({
              month: 'short',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            }),
          }}
        />
      </StateTag>
    );
  }

  return (
    <StateTag variant="lightGreen">
      <FormattedMessage id="shared-menu.status.live" />
    </StateTag>
  );
};

export default SharedMenuStateTag;
